/* =============================================================================
   pl-v4.js — escenas de la cuarta ronda (GSAP vía motion.js)
   ========================================================================== */
(function () {
  'use strict';
  var ONX = (window.ONX = window.ONX || {});
  ONX.scenes = ONX.scenes || {};

  // Beneficios: cada tarjeta ocupa la pantalla; la de abajo se encoge y redondea
  // cuando la siguiente la cubre (sin oscurecerla), y su foto hace un zoom lento.
  ONX.scenes['pl-apila-full'] = function (el, gsap) {
    var cards = Array.prototype.slice.call(el.querySelectorAll('.pbf__card'));
    cards.forEach(function (c, i) {
      var img = c.querySelector('.pbf__img img'), body = c.querySelector('.pbf__body');
      if (img) gsap.fromTo(img, { scale: 1.15 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: c, start: 'top bottom', end: 'top top', scrub: 0.6 } });
      if (body) gsap.from(body.children, { y: 40, opacity: 0, stagger: 0.1, duration: 0.8, ease: 'power3.out', scrollTrigger: { trigger: c, start: 'top 45%', toggleActions: 'play none none reverse' } });
      var next = cards[i + 1];
      if (next) gsap.to(c, { scale: 0.9, borderRadius: 32, ease: 'none', scrollTrigger: { trigger: next, start: 'top bottom', end: 'top top', scrub: 0.4 } });
    });
  };

  // Mecanismo: cada imagen nueva se abre en círculo sobre TODA la pantalla
  ONX.scenes['pl-meca-full'] = function (el, gsap) {
    var imgs = el.querySelectorAll('.pmf__img'), steps = el.querySelectorAll('.pmf__step');
    var prg = el.querySelector('.pmf__prg'), num = el.querySelector('.pmf__num'), n = steps.length; if (!n) return;
    var C = prg ? 2 * Math.PI * 24 : 0;
    if (prg) { prg.style.strokeDasharray = C; prg.style.strokeDashoffset = C * (1 - 1 / n); }
    gsap.set(steps, { autoAlpha: 0, y: 30 }); gsap.set(steps[0], { autoAlpha: 1, y: 0 });
    var tl = gsap.timeline({ defaults: { ease: 'power2.inOut' },
      scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 0.8,
        onUpdate: function (s) {
          var k = Math.min(n - 1, Math.floor(s.progress * n * 0.999));
          if (num) num.textContent = String(k + 1).padStart(2, '0');
          if (prg) prg.style.strokeDashoffset = (C * (1 - (s.progress * (n - 1) + 1) / n)).toFixed(1);
        } } });
    imgs.forEach(function (im) { var i = im.querySelector('img'); if (i) gsap.set(i, { scale: 1.12 }); });
    for (var i = 1; i < n; i++) {
      var prevImg = imgs[i - 1].querySelector('img'), curImg = imgs[i].querySelector('img');
      tl.to(prevImg || imgs[i - 1], { scale: 1, duration: 0.7 }, i - 1)                                  // la actual se acerca despacio
        .fromTo(imgs[i], { clipPath: 'circle(0% at 50% 55%)' }, { clipPath: 'circle(150% at 50% 55%)', duration: 0.55 }, i - 0.45)
        .to(steps[i - 1], { autoAlpha: 0, y: -30, duration: 0.25 }, i - 0.45)
        .to(steps[i], { autoAlpha: 1, y: 0, duration: 0.3 }, i - 0.2);
    }
    var last = imgs[n - 1] && imgs[n - 1].querySelector('img');
    if (last) tl.to(last, { scale: 1, duration: 0.7 }, n - 1);
    tl.to({}, { duration: 0.3 });
  };

  // Cómo usar: abanico fijo (1 izq · 2 centro · 3 der). Al bajar, cada paso se
  // levanta, crece y se anima; los otros se quedan inclinados atrás.
  ONX.scenes['pl-abanico-pasos'] = function (el, gsap, ST, env) {
    var cards = Array.prototype.slice.call(el.querySelectorAll('.pfa__card')), dots = el.querySelectorAll('.pfa__dots i');
    var n = cards.length; if (!n) return;
    var mid = (n - 1) / 2, ang = env.mobile ? 13 : 15, sep = env.mobile ? 28 : 34;   // grados y vw entre tarjetas
    function pose(i, act) {
      var d = i - mid, on = i === act;
      return { rotate: d * ang * (on ? 0.55 : 1), x: d * sep * (on ? 0.18 : 1) + 'vw', y: on ? -34 : Math.abs(d) * 16, scale: on ? 1.06 : 0.86, zIndex: on ? 50 : 10 - Math.abs(d), opacity: on ? 1 : 0.82 };
    }
    // reparto inicial: salen apiladas del centro y se abren en abanico
    cards.forEach(function (c, i) { gsap.set(c, { rotate: 0, x: 0, y: 60, scale: 0.8, opacity: 0 }); });
    var act = -1;
    function show(k) {
      if (k === act) return; act = k;
      cards.forEach(function (c, i) { c.classList.toggle('is-on', i === k); var p = pose(i, k); c.style.zIndex = p.zIndex; gsap.to(c, { rotate: p.rotate, x: p.x, y: p.y, scale: p.scale, opacity: p.opacity, duration: 0.9, ease: 'power3.out', overwrite: 'auto' }); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === k); });
    }
    ST.create({
      trigger: el, start: 'top 60%', end: 'bottom bottom',
      onUpdate: function (s) {
        // el primer 8% es el reparto; el resto se divide en partes iguales, una por paso (más lento)
        var p = Math.max(0, (s.progress - 0.08) / 0.92);
        show(Math.min(n - 1, Math.floor(p * n * 0.999)));
      }
    });
  };
})();
